<script setup lang="ts">
import Overlay from "@/components/Overlay.vue";
import Form from "@/components/Form.vue";
// import ModeratorForm from "@/components/ModeratorForm.vue";
import Modal from "@/components/Modal.vue";
import { useAppLogic } from "@/services/useAppLogic";
import {useAppStore} from "@/store/app"; 
import type { serviceType} from '@/types/form';

const props = defineProps<{
  service: serviceType;
  version: string;
}>();

const appStore = useAppStore();
appStore.setAppVersion(props.version);
appStore.setService(props.service);
console.log(`DSA Widget -> version : ${props.version} - ${__APP_BUILD_DATE__}`);

useAppLogic();

</script>

<template>
  <Overlay />
  <Form />
  <Modal />
  <!-- <ModeratorForm /> -->
</template>
